import React, { useState } from 'react';
import FourLinerAlphaCapitalStencilsCanvas from './FourLinerAlphaCapitalStencilsCanvas';
import FourLinerAlphaSmallStencilsCanvas from './FourLinerAlphaSmallStencilsCanvas';

import FourLinerNumberStencilsCanvas from './FourLinerNumberStencilsCanvas';
import GridNumberStencilsCanvas from './GridNumberStencilsCanvas';
import GridTableStencilsCanvas from './GridTableStencilsCanvas';
import NurseryLinesStencilsCanvas from './NurseryLinesStencilsCanvas';
import CharacterStencilsCanvas from './CharacterStencilsCanvas';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faRuler, faListAlt, faTh, faA, fa1, faTable, faList, faSmile, faDice } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './NotesCanvas.css';
import axios from 'axios';
import { useSelector } from 'react-redux';

const canvasComponents = [
  { icon: faA, component: FourLinerAlphaCapitalStencilsCanvas, name: 'Alphabet Capital Stencils'},
  { icon: faA, component: FourLinerAlphaSmallStencilsCanvas, name: 'Alphabet Small Stencils'},
  { icon: fa1, component: FourLinerNumberStencilsCanvas, name: 'Number Stencils' },
  { icon: faTable, component: GridNumberStencilsCanvas, name: 'Counting Number Stencils', props: { rows: 10, cols: 10 } },
  { icon: faTable, component: GridTableStencilsCanvas, name: 'Multiplication Table Stencils', props: { rows: 10, cols: 10 } },
  { icon: faSmile, component: NurseryLinesStencilsCanvas, name: 'Lines Stencils', props: { rows: 3, cols: 3 } },
  { icon: faDice, component: CharacterStencilsCanvas, name: 'One-By-One'},
];

const StencilsCanvas = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const [overlayContent, setOverlayContent] = useState(null);

  const handleIconClick = (Component, props = {}) => {
    setOverlayContent(() => <Component {...props} onClose={handleCloseOverlay} />);
  };

  const handleCloseOverlay = () => {
    setOverlayContent(null);
  };

  const handleBackToHome = () => {
    navigate("/touchbook-home")
  };


  return (
    <div className="full-screen-overlay">
      <div className='flex flex-col'>
        <div className='flex justify-center items-center my-4'>
            <p className='text-white bg-lime-800 text-xl font-semibold rounded-lg px-6 py-2 shadow-lg'>
                {authState.user.name}'s Digital Stencils 
            </p>
        </div>
        <div className="canvas-grid">
            {canvasComponents.map((item, index) => (
                <div 
                key={index} 
                className="icon text-lime-400" 
                onClick={() => handleIconClick(item.component, item.props)}
                >
                <FontAwesomeIcon className="text-lime-400" icon={item.icon} size="200x" />
                <p className='text-lime-400'>{item.name}</p>
                </div>
            ))}
        </div>
        {overlayContent && (
            <div className="overlay" style={{backgroundColor: 'black', opacity: 1}}>
            {overlayContent}
            </div>
        )}
        <div>
            <button onClick={handleBackToHome}>Close</button>
        </div>
    </div>
   </div>
  );
};

export default StencilsCanvas;

